import cn from 'classnames';

import classes from './Title.module.scss';
import { TitleProps } from './Title.props';

export const Title = ({ tag = 'h1', className, children, ...props }: TitleProps): JSX.Element => {

  switch (tag) {
    case 'h1':
      return (
        <h1 {...props} className={cn(className, classes.h1)}>
          {children}
        </h1>
      );
    case 'h2':
      return (
        <h2
          {...props}
          className={cn(className, classes.h2)}
        >
          {' '}
          {children}
        </h2>
      );
    case 'h3':
      return (
        <h3 {...props} className={cn(className, classes.h3)}>
          {children}
        </h3>
      );
    case 'h4':
      return (
        <h4 {...props} className={cn(className, classes.h4)}>
          {children}
        </h4>
      );
    case 'h5':
      return (
        <h5 {...props} className={cn(className, classes.h5)}>
          {children}
        </h5>
      );
  }
};
